var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M12,12h2v-2h2v-2h-2v-2h-2v2h-2v2h2v2ZM2,16c-.5,0-1-.2-1.4-.6-.4-.4-.6-.9-.6-1.4V2C0,1.5.2,1,.6.6c.4-.4.9-.6,1.4-.6h6l2,2h8c.5,0,1,.2,1.4.6.4.4.6.9.6,1.4v10c0,.5-.2,1-.6,1.4-.4.4-.9.6-1.4.6H2ZM2,14h16V4h-8.8l-2-2H2v12Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFolder);
export default __webpack_public_path__ + "static/media/add_folder.8855cc6fcab6b4bd695f12eb27856585.svg";
export { ForwardRef as ReactComponent };